<template>
  <div v-if="isLoading"><sync-loader class="text-center" color="white"></sync-loader></div>
</template>

<script>
  import swal from 'sweetalert2'
  import {USER_CONFIRM_EMAIL} from "../store/actions/userConst";
  import syncLoader from 'vue-spinner/src/PulseLoader.vue'
  import { mapGetters } from 'vuex';

  export default {
    name: "Confirm",
    computed: {
      ...mapGetters(['isLoading'])
    },
    components: {syncLoader},
    props: {
      token: {type: String, default: null},
      uid: {type: String, default: null}
    },
    created() {
      if(this.uid && this.token) {
        this.$store.dispatch(USER_CONFIRM_EMAIL, {uid: this.uid, token: this.token})
          .then(()=>{
            swal({
              type: 'success',
              text: this.$t('c_successful_confirmation'),
              keydownListenerCapture: true,
              allowOutsideClick: false
            })
              .then(()=>this.$router.push({name: 'login'}))
          })
          .catch(err=>{
            console.log(err)
            const code = this.$ObjValidate(() => err.response.data.error.code) ? err.response.data.error.code : '';
            switch (code) {
              case 'USER_NOT_FOUND':
                swal({
                  type: 'error',
                  text: this.$t('c_user_not_found'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                  .then(()=>this.$router.push({name: 'home'}))
                break
              case 'INVALID_TOKEN':
                swal({
                  type: 'error',
                  text: this.$t('c_wrong_token'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                  .then(()=>this.$router.push({name: 'home'}))
                break
              default:
                swal({
                  type: 'error',
                  text: this.$t('text16'),
                  keydownListenerCapture: true,
                  allowOutsideClick: false
                })
                  .then(()=>this.$router.push({name: 'home'}))
                break
            }
          })
      } else {
        swal({
          type: 'error',
          text: this.$t('c_wrong_link'),
          keydownListenerCapture: true,
          allowOutsideClick: false
        })
        this.$router.push({name: 'home'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  div {
    width: 100%;
    text-align: center;
  }
</style>